const retryFetch =
  (times = 2, timeout, acceptEmptyResponse = false) =>
  (url, options) => {
    return new Promise((resolve, reject) =>
      fetch(url, options)
        .then((response) => {
          if (!response.ok) {
            return Promise.reject(response);
          }
          if (acceptEmptyResponse) {
            return response
              .text()
              .then((text) => (text.length ? JSON.parse(text) : {}))
              .then((json) => resolve(json))
              .catch((err) => reject(err));
          }
          return response
            .json()
            .then((json) => resolve(json))
            .catch((err) => reject(err));
        })
        .catch((response) => {
          const status = response && response.status;
          const shouldReject = times <= 1 || status === 401 || status === 404;
          if (shouldReject) {
            return reject(
              `Failed to fetch from: ${url}. Status code: ${status}.`
            );
          }

          return resolve(
            new Promise((res) =>
              setTimeout(
                () =>
                  res(
                    retryFetch(
                      times - 1,
                      timeout,
                      acceptEmptyResponse
                    )(url, options)
                  ),
                timeout
              )
            )
          );
        })
    );
  };

module.exports = retryFetch;
